/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getPrivacySettings} from '../api'

 export const useQueryGetPrivacySettings = createReactQueryHook('getPrivacySettings', getPrivacySettings)
